module.exports = __webpack_public_path__ + "img/pr-7.cc0ec2fd.png";